<script setup>
const { injectSkinClasses } = useSkins()

// ℹ️ This will inject classes in body tag for accurate styling
injectSkinClasses()

// chagne the theme to light only
import {
  useConfigStore,
} from '@core/stores/config'

const configStore = useConfigStore()

await onMounted(() => configStore.theme = 'light')

// chagne the theme to light only
import SiteMessage from '@/components/share/message.vue'
</script>

<template>
  <div class="layout-wrapper layout-blank">
    <ClientOnly>
      <SiteMessage />
    </ClientOnly>
    <slot />
  </div>
</template>

<style>
.layout-wrapper.layout-blank {
  flex-direction: column;
}
</style>
